import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { PhoneAccountProvider } from "../../contexts/PhoneAccountContext";
import { LiveChatProvider } from "../../contexts/LiveChatContext";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = () => {
      const userStr = localStorage.getItem("user");
      const user = userStr ? JSON.parse(userStr) : null;
      const currentPath = window.location.pathname;
      
      if (!user) {
        navigate("/login");
      } else {
        // Allow access to all pages regardless of profile completion
        // Business details will be checked only during subscription purchase
        setTimeout(() => setIsLoading(false), 500);
      }
    };
    checkUser();
  }, [navigate]);

  const toggleSidebar = () => setSidebarOpen((v) => !v);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Allow scrolling globally
    document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [sidebarOpen]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col items-center justify-center">
        <div className="w-20 h-20 relative">
          <div 
            className="w-20 h-20 rounded-full border-t-4 border-b-4 animate-spin" 
            style={{ borderColor: "#EEFA94" }}
          />
          <div
            className="w-20 h-20 rounded-full border-r-4 border-l-4 border-transparent animate-spin absolute top-0 left-0"
            style={{ 
              borderRightColor: "#17181b",
              animationDirection: "reverse", 
              animationDuration: "1s" 
            }}
          />
        </div>
        <h2 className="mt-6 text-2xl font-bold text-gray-900">
          Loading BluTec PING...
        </h2>
        <p className="text-gray-600 text-sm mt-2">
          Please wait while your dashboard is prepared
        </p>
      </div>
    );
  }

  return (
    <PhoneAccountProvider>
      <LiveChatProvider>
        <div className="flex min-h-screen bg-[#ffff]">
          <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

          {/* Main content wrapper - 80px (20rem) margin for sidebar on desktop */}
          <div className="flex-1 lg:ml-20 flex flex-col min-h-screen">
            {/* Fixed Header */}
            <Header toggleSidebar={toggleSidebar} />

            {/* Main content with top padding for fixed header */}
            <main className="flex-1 pt-14 md:pt-16">
              <div className="w-full">
                {children}
              </div>
            </main>
          </div>
        </div>
      </LiveChatProvider>
    </PhoneAccountProvider>
  );
};

export default Layout;